/* GB — Desktop hover menus — customization of Dawn header behavior.
   Foundation: Dawn's details-disclosure.js (header-menu / details-disclosure).
   Opens mega menus and dropdowns on pointer hover at desktop widths instead
   of requiring a click. Applies only on hover-capable devices at 990px+;
   touch, keyboard, and mobile keep stock Dawn behavior untouched.

   Reuses: Dawn's <details> open attribute (the native toggle event still
   fires, so HeaderMenu.onToggle animations and sticky preventHide run
   exactly as on click), DetailsDisclosure.close() (keeps aria-expanded in
   sync), stock focusout-to-close for keyboard users.
   New code: this file only — mouseenter/mouseleave listeners with a short
   close delay so the pointer can cross the gap between link and panel. */

(() => {
  const HOVER_MQ = window.matchMedia('(min-width: 990px) and (hover: hover)');
  const CLOSE_DELAY_MS = 150;

  const init = () => {
    document.querySelectorAll('.header__inline-menu header-menu, .header__inline-menu details-disclosure').forEach((disclosure) => {
      const details = disclosure.querySelector('details');
      const summary = details?.querySelector('summary');
      if (!details || !summary) return;

      let closeTimer;

      const close = () => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
        } else {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }
      };

      const open = () => {
        clearTimeout(closeTimer);
        // Only one top-level menu open at a time.
        document.querySelectorAll('.header__inline-menu details[open]').forEach((other) => {
          if (other !== details && !other.contains(details) && !details.contains(other)) {
            other.closest('header-menu, details-disclosure')?.close?.();
          }
        });
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
      };

      disclosure.addEventListener('mouseenter', () => {
        if (HOVER_MQ.matches) open();
      });

      disclosure.addEventListener('mouseleave', () => {
        if (!HOVER_MQ.matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          // Don't close under a keyboard user who focused into the menu.
          if (!disclosure.contains(document.activeElement)) close();
        }, CLOSE_DELAY_MS);
      });

      /* GB — click navigates on hover devices: hover already opens the
         menu, so the top-level item acts as a plain link to its nav URL
         (data-gb-url, emitted by the menu snippets). Guards keep every
         other behavior stock: touch devices (no hover) keep click-to-
         toggle so the mega menu stays reachable, and keyboard activation
         (Enter/Space fires click with event.detail === 0) keeps toggling
         for accessibility. */
      summary.addEventListener('click', (event) => {
        if (!HOVER_MQ.matches) return;
        if (event.detail === 0) return;
        const url = summary.getAttribute('data-gb-url');
        if (!url) return;
        event.preventDefault();
        window.location.href = url;
      });
    });
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init, { once: true }) : init();
})();
